import get from 'lodash/get';

export const isChannelEnabled = (survey, channel) => !!get(survey, `channels.${channel}.enabled`);
